import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_46: DocMigration = {
  maxSchemaVersion: "0.0.46",
  description:
    "Resolve stair outlines in stair blocks, flatten stair blocks into separate table, assign self persistent ids to stair blocks/systems",
  apply(json: any) {
    const { stairSystems, referenceGeom } = json;

    if (json.stairBlocks) {
      return json;
    }

    json.stairBlocks = {};

    if (stairSystems) {
      const stairBlocks = json.stairBlocks;

      let stairSystemCount = 0;
      for (const stairSystemId in stairSystems) {
        const stairSystem = stairSystems[stairSystemId];
        stairSystem.id = stairSystemId;
        stairSystem.sortIndex = stairSystemCount++;

        for (let i = 0; i < stairSystem.stairBlocks.length; i++) {
          const block = stairSystem.stairBlocks[i];

          const { geomId } = block;

          delete block.geomId;

          const geom = referenceGeom[geomId];

          if (!geom) {
            continue;
          } else {
            block.outline = geom.geom;
            block.edgeIds = geom.edgeIds;
            if (block.type === "RUN" && !block.startEdgeId) {
              block.startEdgeId = block.edgeIds[0];
            }
          }

          const stairBlockId = uid();
          block.id = stairBlockId;
          block.sortIndex = i;
          block.stairSystemId = stairSystemId;
          stairBlocks[stairBlockId] = block;
        }

        delete stairSystem.stairBlocks;
      }
    }
    return json;
  },
};

export default migration_0_0_46;
